/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tab_DemandsInputs */

const cs_clients_tab_demands = /** @type {(inputs: Clients_Tab_DemandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávky`)
};

const en_clients_tab_demands = /** @type {(inputs: Clients_Tab_DemandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demands`)
};

/**
* | output |
* | --- |
* | "Demands" |
*
* @param {Clients_Tab_DemandsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tab_demands = /** @type {((inputs?: Clients_Tab_DemandsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tab_DemandsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tab_demands(inputs)
	return cs_clients_tab_demands(inputs)
});